import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Autoplay, Pagination, Mousewheel } from "swiper/modules";

const Banner = ({ bannerData }) => {
  return (
    <div className="w-full mx-auto">
      <Swiper
        modules={[Pagination, Autoplay, Mousewheel]}
        spaceBetween={3}
        slidesPerView={1}
        pagination={{
          clickable: true,
          renderBullet: (_, className) => `<span class="${className}"></span>`, // Hide numbers under dots
        }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        mousewheel={{ forceToAxis: true }}
        className="overflow-hidden"
      >
        {bannerData.map((banner, index) => (
          <SwiperSlide key={index}>
            <img
              src={banner.large}
              alt={`Banner ${index + 1}`}
              className="hidden md:block w-full sm:h-[550px] 2xl:h-[700px] object-cover mt-10"
            />
            <img
              src={banner.small}
              alt={`Banner ${index + 1}`}
              className="block md:hidden w-full h-[500px] object-cover mt-10"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
